function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 .89l-.63.6L0 12.86l1.26 1.26L2.38 13v10.11h7.87v-8.75h3.5v8.75h7.87V13l1.12 1.12L24 12.86 12.63 1.49 12 .89zm0 2.49l7.87 7.87v10.11H15.5v-8.75h-7v8.75H4.13V11.25L12 3.38z"
});

function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "893ba193a0c73a406280a36cbe559d01.svg";
export { SvgHouse as ReactComponent };